import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { authService } from '@/features/auth/auth-service'
import { AuthError } from '@/features/auth/components/auth-error'
import { AuthLoading } from '@/features/auth/components/auth-loading'
import { useLoginRedirectStore } from '../stores/login-redirect-store'

export const LoginCallbackPage = () => {
  const navigate = useNavigate()
  const [error, setError] = useState<Error | null>(null)
  const handled = useRef(false)

  useEffect(() => {
    if (handled.current) {
      return
    }

    handled.current = true

    void (async () => {
      try {
        const result = await authService.handleRedirectPromise()

        if (result) {
          const destination = useLoginRedirectStore.getState().fetchRedirectDestination()
          navigate(destination || '/', { replace: true })
          return
        }

        navigate('/login', { replace: true })
      } catch (e) {
        handled.current = false
        setError(e instanceof Error ? e : new Error('Sign-in failed'))
      }
    })()
  }, [navigate])

  if (error) {
    return (
      <main className="flex min-h-dvh items-center justify-center p-6">
        <AuthError
          error={error}
          onRetry={() => navigate('/login', { replace: true })}
        />
      </main>
    )
  }

  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <AuthLoading />
    </main>
  )
}
